module.exports = __webpack_public_path__ + "img/图1-24绘图铅笔的削制形状和使用方法.ec23bb00.png";